import React, { useState, useRef, useEffect } from "react";
import {
  FaChevronUp,
  FaChevronDown,
  FaTimes,
  FaCheck,
  FaUndoAlt,
} from "react-icons/fa";
import Modal from "../../../../../../PageCostumerProfile/PCPContents/Contents/Order History/Modal/Modal";
import RefundForm from "../Modal/RefundForm/RefundForm";

function _OrderRow({
  order,
  isSelected,
  onSelect,
  expandedId,
  setExpandedId,
  handleUpdateAvailability,
}) {
  const [transactions, setTransactions] = useState({});
  const [activeTab, setActiveTab] = useState("history");
  const isExpanded = expandedId === order.COI_ID;
  const contentRef = useRef(null);
  const [height, setHeight] = useState("0px");
  const [isModalOpen, setModalOpen] = useState("");
  const handelModal = (cmd) => {
    setModalOpen(cmd); // open modal
  };
  //console.log("order: ", order);
  // ✅ Animate expand/collapse
  const handleRefund = async (reason, selectedFile) => {
    const confirm = window.confirm(
      `Are you sure you want to refund payment for ID ${order.COI_ID}?`
    );
    if (!confirm) return;

    try {
      const formData = new FormData();
      formData.append("COI_ID", order.COI_ID); // text field
      formData.append("reason", reason);
      if (selectedFile) formData.append("proof", selectedFile); // file field

      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/payments/refund-payment-single`,
        {
          method: "POST",
          body: formData, // no headers — browser sets multipart boundary automatically
          credentials: "include",
        }
      );

      if (res.ok) {
        console.log(`✅  Item ${order.COI_ID} refunded`);
        alert(`✅  Item ${order.COI_ID} refunded`);
      } else {
        console.error("Failed to decline transaction");
      }
    } catch (err) {
      console.error("Error declining transaction:", err);
    }
  };

  const formatToMMDDYYYY = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);

    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const yyyy = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert to 12-hour format

    return `${mm}/${dd}/${yyyy} ${hours}:${minutes} ${ampm}`;
  };
  useEffect(() => {
    if (contentRef.current) {
      setHeight(isExpanded ? `${contentRef.current.scrollHeight}px` : "0px");
    }
  }, [isExpanded, transactions, activeTab]);

  // ✅ Automatically load transaction history when expanded
  useEffect(() => {
    const loadTransactionHistory = async () => {
      //console.log("order.COI_ID:", order.COI_ID);
      if (isExpanded && !transactions[order.COI_ID]) {
        try {
          const res = await fetch(
            `${process.env.REACT_APP_BASE_URL}api/orders/get-transaction-history/${order.COI_ID}`
          );
          const data = await res.json();
          setTransactions((prev) => ({
            ...prev,
            [order.COI_ID]: data.transactions,
          }));
        } catch (error) {
          console.error("Failed to load transaction history:", error);
        }
      }
    };

    loadTransactionHistory();
  }, [isExpanded, order.COI_ID, order.CP_ID, transactions]);

  return (
    <>
      <tr>
        {/* Expand / Collapse Icon */}
        <td
          className="td-toggle-icon"
          onClick={() => setExpandedId(isExpanded ? null : order.COI_ID)}
          style={{ cursor: "pointer", width: "40px" }}
        >
          {isExpanded ? (
            <FaChevronUp className="toggle-icon" title="Collapse" />
          ) : (
            <FaChevronDown className="toggle-icon" title="Expand" />
          )}
        </td>

        {/* Checkbox */}
        <td>
          <input type="checkbox" checked={isSelected} onChange={onSelect} />
        </td>

        {/* Product Info */}
        <td>
          <img
            src={`${process.env.REACT_APP_BASE_URL}Assets/Products/${
              order.PD_ID
            }/${order.PD_ProductPicPath[0] ?? "no-image.png"}`}
            alt={order.PD_Name}
            className="ord-prod-pic"
          />
        </td>
        <td>{order.PD_Name}</td>
        <td>{order.CP_Firstname + " " + order.CP_Lastname}</td>
        <td>{order.PD_ProductType}</td>
        <td>{formatToMMDDYYYY(order.COI_Created_At)}</td>
        <td>PHP {order.COI_UnitPrice}</td>
        <td>{order.COI_Quantity}</td>
        <td>PHP {order.COI_DP * order.COI_Quantity}</td>
        <td>PHP {order.COI_TotalAmount * order.COI_Quantity}</td>
        <td>PHP {order.COI_Downpayment}</td>
        <td>PHP {order.COI_Balance}</td>
        <td>{order.COI_IsReady === "true" ? "Waiting for FP" : "DP Paid"}</td>

        {/* Action Icons */}
        <td className="td-actions">
          <div className="td-action-btns-wrapper">
            {order.COI_IsReady === "true" ? (
              <FaTimes
                className="cancel"
                title="Mark as Not Available"
                style={{ color: "red", cursor: "pointer" }}
                onClick={() => handleUpdateAvailability(order)}
              />
            ) : (
              <FaCheck
                className="available"
                title="Mark as Available"
                style={{ color: "green", cursor: "pointer" }}
                onClick={() => handleUpdateAvailability(order)}
              />
            )}

            <FaUndoAlt
              className="available"
              title="REFUND"
              style={{ color: "#6c757d", cursor: "pointer" }}
              onClick={() => {
                handelModal("refund");
              }}
            />
          </div>
        </td>
      </tr>

      {/* Expandable Section */}
      <tr>
        <td
          className="td-other-order-field"
          colSpan={15}
          style={{ padding: 0, border: 0 }}
        >
          <div
            ref={contentRef}
            style={{
              maxHeight: height,
              overflow: "hidden",
              transition: "max-height 0.4s ease, opacity 0.3s ease",
              opacity: isExpanded ? 1 : 0,
            }}
          >
            {/* Tab Content */}
            <div className="tab-content" style={{ padding: "10px 25px" }}>
              {/* ✅ HISTORY TAB */}
              {activeTab === "history" && (
                <div className="order-history">
                  <h4> Transaction History</h4>

                  {transactions[order.COI_ID] ? (
                    transactions[order.COI_ID].length > 0 ? (
                      transactions[order.COI_ID].map((tx, idx) => (
                        <div key={idx} style={{ marginBottom: "10px" }}>
                          <p>
                            <strong>{formatToMMDDYYYY(tx.DatePurchase)}</strong>{" "}
                            – {tx.PaymentType} via {tx.PaymentMethod} – PHP{" "}
                            {tx.PaymentAmount}
                            <br />
                            Status: {tx.Status} <br />
                            <a
                              href={`${process.env.REACT_APP_BASE_URL}Assets/purchase_order/${tx.TransactionID}/${tx.Receipt}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                color: "blue",
                                cursor: "pointer",
                              }}
                            >
                              <span>VIEW RECEIPT</span>
                            </a>
                          </p>

                          <ul>
                            {tx.OrderItems.map((item, i) => {
                              // ✅ Highlight the item if it matches the current order product
                              const isHighlighted =
                                item.ProductID === order.PD_ID ||
                                item.ProductName === order.PD_Name;

                              return (
                                <li
                                  key={i}
                                  style={{
                                    backgroundColor: isHighlighted
                                      ? "gray"
                                      : "transparent", // light blue
                                    borderRadius: "5px",
                                    padding: "4px 8px",
                                    fontWeight: isHighlighted
                                      ? "600"
                                      : "normal",
                                    transition: "background-color 0.3s ease",
                                  }}
                                >
                                  {item.ProductName} × {item.Quantity} @ PHP{" "}
                                  {item.UnitPrice} = PHP {item.TotalAmount} —
                                  Deposited: PHP {item.Deposited} Balance: PHP{" "}
                                  {item.Balance}
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      ))
                    ) : (
                      <p>No transactions available</p>
                    )
                  ) : (
                    <p>Loading transaction history...</p>
                  )}
                </div>
              )}
            </div>
          </div>
        </td>
      </tr>
      <Modal
        isModalOpen={isModalOpen}
        onClose={() => {
          setModalOpen(null);
        }}
      >
        <RefundForm
          onClose={() => setModalOpen(null)}
          handleRefund={handleRefund}
        />
      </Modal>
    </>
  );
}

export default _OrderRow;
